import { connect } from 'react-redux/dist/react-redux';
import MapButton from '../components/MapButton';
const mapStateToProps = () => ({
  selected: true,
});
export default connect(mapStateToProps)(MapButton);
